import { gql } from 'graphql-request'

export const coreUsersQuery = gql`
  query CoreUsers($filter: FindCoreUsersFilters, $search: String) {
    coreUsers(filter: $filter, search: $search) {
      results {
        node {
          id
          v1Id
          email
          firstName
          lastName
          phone
          status
          profileImage {
            status
            versions {
              type
              url
              width
              height
              fileSize
              format
            }
          }
          about
          hobbies
          instagramHandle
          access {
            rules {
              id
              accessPolicy {
                id
                name
                permissions {
                  access
                  corporate
                  site
                }
              }
              type
              siteGroups {
                id
                name
              }
              sites {
                id
                name
              }
              isAllSites
            }
            levels
          }
        }
      }
    }
  }
`
